import { render, staticRenderFns } from "./CreateEmail.vue?vue&type=template&id=1f649b36"
import script from "./CreateEmail.vue?vue&type=script&lang=ts"
export * from "./CreateEmail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports